import { render } from "./GameText.vue?vue&type=template&id=e831fb22"
const script = {}

import "./GameText.vue?vue&type=style&index=0&id=e831fb22&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__